import React from 'react'
import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import Container from '@mui/material/Container'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import SchoolIcon from '@mui/icons-material/School'
import useTheme from '@mui/material/styles/useTheme'

function Welcome() {

  const theme = useTheme()

    return (
        <Container maxWidth='sm' style={{textAlign:'center', marginTop:theme.spacing(1)}}>
            <img
                src='profile.png'
                style={{width:200, height:200, display:'block', margin:'0 auto'}}
            />
            <Box mt={2}>
                <Typography variant='h4' component='h1' gutterBottom>
                    Hi, I'm Ethan.
                </Typography>
                <Typography variant='body1' paragraph>
                    I'm an Assistant Teaching Professor of Artificial Intelligence in the Computer Science Department at Worcester Polytechnic Institute, with affiliations with the Data Science and Learning Sciences & Technology programs. My background includes various engineering and consulting roles, postdoctoral research in Machine Learning at École Polytechnique Fédérale de Lausanne, and a Ph.D. in Data Science from Worcester Polytechnic Institute.
                </Typography>
                <Typography variant='body1' paragraph>
                    My academic research has focused on personalized learning using a combination of reinforcement learning, user modeling, causal inference, and large language models, and my industry work has focused on automating human tasks through the development of novel algorithms and AI-assisted processes.
                </Typography>
                <Typography variant='body1' paragraph>
                    Outside of work, I enjoy game development, pottery, music, and foraging.
                </Typography>
                <Box mt={-1}>
                    <IconButton href='https://scholar.google.com/citations?user=QIr4dxAAAAAJ' target='_blank' rel='noopener' size='large'>
                        <SchoolIcon fontSize='inherit'/>
                    </IconButton>
                    <IconButton href='https://www.linkedin.com/in/ethan-prihar' target='_blank' rel='noopener' size='large'>
                        <LinkedInIcon fontSize='inherit'/>
                    </IconButton>
                </Box>
            </Box>
        </Container>
    )
}

export default Welcome